module.exports = __webpack_public_path__ + "img/CAST证书_01.094c7b71.webp";